// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Card----card-module---container---SvEV0","imgContainer":"src-components-Card----card-module---imgContainer---2CQoy","img":"src-components-Card----card-module---img---1Uiwc","heading":"src-components-Card----card-module---heading---1Bnk6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/card.module.scss
// module id = 258
// module chunks = 35783957827783